/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useLayoutEffect, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getAccionistas, getAccionistasPorId, getDirectores, getDirectoresPorId, getInfoCliente, getInfoClientePorId, getInfoCustomerPorId } from "../../API/Clientes/ClientesRequest";
import { logoPPFBase64 } from "../../Utils/Imagenes/Imgs";
import { getLabel } from "../../Services/Language/LanguageService";
import {FormatoInscripcionLang} from './FormatoInscripcionLang'

// ------------------ COMPONENTES DE BASE--------------------------


// ------------------- CONSULTAS A LA API---------------------------


// ------------------ COMPONENTES DE NECESARIOS--------------------------


// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FormatoInscripcionClientes = () => {
  const {IdCustomer, Idioma, Token} = useParams();
  // const [idioma, setIdioma] = useState(2);

  const obtenerInformacion = async (IdCustomer, Idioma) => {
    const customerTempo = await getInfoCustomerPorId(IdCustomer, Token);
    const customerInfoTempo = await getInfoClientePorId(IdCustomer, Token);
    const accionistasTempo = await getAccionistasPorId(IdCustomer, Token);
    const directoresTempo = await getDirectoresPorId(IdCustomer, Token);

    let IdLanguage = Number(Idioma)
    generarPDF(customerTempo[0], customerInfoTempo[0], accionistasTempo, directoresTempo, IdLanguage);
  };

  useEffect(() => {
    if (IdCustomer) {
      obtenerInformacion(IdCustomer, Idioma);
      // setIdioma(Idioma)
    }
  }, [IdCustomer, Idioma]);



  const generarPDF = async (customerTempo, customerInfoTempo, accionistasTempo, directoresTempo, Idioma) => {
    let Language = Idioma === 1 ? 'en' : 'es'

    const fecha = new Date();
    const opciones = { year: 'numeric', month: 'short', day: 'numeric' };
    const fechaFormateada = fecha.toLocaleDateString('en-US', opciones);

    let contenido1 =
    [
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 550,
            y2: 0, // Ajusta x2 para que la línea sea más larga o más corta
            lineWidth: 0.3, // Espesor de la línea
          },
        ],
      },
      {
        text: `${getLabel(FormatoInscripcionLang, "textInitial", Language)}`,
        style: "textInitial",
        margin: [0, 10, 0, 10],
      },

      // -------------------------------------------------------------------- PARTE I --------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteI",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
      },

      {
        table: {
          widths: ["28%", "72%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"dateA",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",
                margin: [0,10,0,0],
              },
              { 
                text: customerInfoTempo?.DateEditStr || '',
                border: [false, false, false, true],
                style: "infoTablas",
                margin: [0,10,0,0],
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"name",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerTempo?.CustomerName || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"address",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerTempo?.Address || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"billed",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.BilledToAddress || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["46%", "54%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"business",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerTempo?.RTN || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["9%", "29%", "5%","25%", "7%", "25%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Tel",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.Tel?.substring(0,35) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Fax:",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.Email?.substring(0,26) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["28%", "40%", "7%","25%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Representante",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.NombreRepresentanteLegal?.substring(0, 49) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.CorreoRepresentante?.substring(0,26) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["15%", "*"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"TipoPago",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.IdTipoPagoCliente === 1 ? 'No' : getLabel(FormatoInscripcionLang,"Si",Language)}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["8%", "32%", "8%","27%", "9%", "16%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"InfFinanciera",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasTitle",
                colSpan: 6,
                margin: [0,20,0,0],
              },
              { 
                text: ``,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: ``,
                border: [false, false, false, false],
                style: "infoTablas",

              },
              { 
                text: ``,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: ``,
                border: [false, false, false, false],
                style: "infoTablas",

              },
              { 
                text: ``,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Nombre",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.NombreContactoFin1?.substring(0, 34)  || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.CorreoContactoFin1?.substring(0, 35) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Tel",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.TelefonoContactoFin1?.substring(0, 20) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Nombre",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.NombreContactoFin2?.substring(0, 34) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.CorreoContactoFin2?.substring(0, 35) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Tel",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.TelefonoContactoFin2?.substring(0, 20) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["15%", "85%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"MetodoPago",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.TipoPago || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ]
          ],
        },
        margin: [0, 10, 0, 0],
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },

      // -------------------------------------------------------------------- PARTE II --------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteII",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 20, 0, 10],
      },

      //DIRECTORES
      {
        text: `${getLabel(FormatoInscripcionLang, "directores", Language)}`,
        style: "infoTablasTitle",
        margin: [0, 0, 0, 5],
      },
      directoresTempo.length >=1 ?
      {
        table: {
          widths: ["3%", "34%", "18%", "25%", "20%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"No.",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"NombreT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Posicion",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"EmailT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Nacionalidad",Language)}`,
                style: "infoTablasHeader",
              },
            ],
            // Cuerpo de la tabla
            ...directoresTempo.map((director, index) => [
              { text: `${index + 1}`, style: "infoTablas"},
              { text: `${director.NombreDirector?.substring(0, 40)}`, style: "infoTablas"},
              { text: `${director.Posicion?.substring(0, 20)}`, style: "infoTablas"},
              { text: `${director.EmailDirector?.substring(0, 25)}`, style: "infoTablas"},
              { text: `${director.NacionalidadDirector}`, style: "infoTablas"},
            ])
          ],
        },
        layout: 'lightHorizontalLines'
      } 
      :
      {
        table: {
          widths: ["90%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"NoDatosDirectores",Language)}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      }
      ,
      ...(directoresTempo.length + accionistasTempo.length > 11
        ? [{ text: '', pageBreak: 'after' }] // Insertar salto de página
        : []),
      

      //ACCIONISTAS
      {
        text: `${getLabel(FormatoInscripcionLang, "accionistas", Language)}`,
        style: "infoTablasTitle",
        margin: [0, 20, 0, 5],
      },
      accionistasTempo.length >=1 ? 
      {
        table: {
          widths: ["4%", "35%", "21%", "21%", "19%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"No.",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"NombreT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Identificacion",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Porcentaje",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Nacionalidad",Language)}`,
                style: "infoTablasHeader",
              },
            ],
            // Cuerpo de la tabla
            ...accionistasTempo.map((accionista, index) => [
              { text: `${index + 1}`, style: "infoTablas"},
              { text: `${accionista.NombreAccionista?.substring(0, 40)}`, style: "infoTablas"},
              { text: `${accionista.IdentificacionAccionista?.substring(0, 25)}`, style: "infoTablas"},
              { text: `${accionista.PorcentajeParticipacion} %`, style: "infoTablasCenter"},
              { text: `${accionista.Nacionalidad}`, style: "infoTablas"},
            ])
          ],
        },
        layout: 'lightHorizontalLines'
      } :
      {
        table: {
          widths: ["90%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"NoDatosAccionistas",Language)}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      }
      ,
      ...((accionistasTempo.length + directoresTempo.length) > 6 && (accionistasTempo.length + directoresTempo.length) <= 10
      ? [{ text: '', pageBreak: 'after' }] // Agregar el salto de página solo si la condición es verdadera
      : []),
      


  
      // ----------------------------------------------------------------PARTE III--------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteIII",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 10, 0, 10],
      },

      ...((accionistasTempo.length + directoresTempo.length) > 3 && (accionistasTempo.length + directoresTempo.length) <= 10
      ? [{ text: '', pageBreak: 'after' }] // Agregar el salto de página solo si la condición es verdadera
      : []),

      //Customer
      {
        text: `${getLabel(FormatoInscripcionLang, "customer", Language)}`,
        style: "infoTablasTitle",
        margin: [0, 0, 0, 5],
      },

      customerInfoTempo?.RefNombre1 || customerInfoTempo?.RefNombre2 ?

      {
        table: {
          widths: ["4%", "27%","31%", "20%", "18%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"No.",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"NombreC",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"NombreContacto",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"EmailT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"TelT",Language)}`,
                style: "infoTablasHeader",
              },
            ],
            customerInfoTempo?.RefNombre1 ? 
            [
              {
                text: `1`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.CompanyRefComercial1 || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.RefNombre1 || ''}`,
                style: "infoTablas",
              },
              {
                text: `${(customerInfoTempo?.RefCorreo1)  || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.RefTelefono1 || ''}`,
                style: "infoTablas",
              },
            ] : null,

            customerInfoTempo?.RefNombre2 ? 
            [
              {
                text: `2`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.CompanyRefComercial2 || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.RefNombre2 || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.RefCorreo2 || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.RefTelefono2|| ''}`,
                style: "infoTablas",
              },
            ] : null,
          ],
        },
        layout: 'lightHorizontalLines'
      } :

      {
        table: {
          widths: ["90%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"NoDatosReferencias",Language)}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      },

      ...((accionistasTempo.length + directoresTempo.length === 0 )
      ? [{ text: '', pageBreak: 'after' }] // Agregar el salto de página solo si la condición es verdadera
      : []),

      //Bancaria
      {
        text: `${getLabel(FormatoInscripcionLang, "bancos", Language)}`,
        style: "infoTablasTitle",
        margin: [0, 10, 0, 5],
      },
      
      customerInfoTempo?.NombreRefBancaria1 ? 
      {
        table: {
          widths: ["3%", "28%","31%", "20%", "18%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"No.",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"BankName",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"NombreContacto",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"EmailT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"TelT",Language)}`,
                style: "infoTablasHeader",
              },
            ],
            [
              {
                text: `1`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.BankName1  || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.NombreRefBancaria1  || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.CorreoRefBancaria1 || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.TelefonoRefBancaria1  || ''}`,
                style: "infoTablas",
              },
            ],

            customerInfoTempo?.NombreRefBancaria2 ?
            [
              {
                text: `2`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.BankName1  || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.NombreRefBancaria2  || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.CorreoRefBancaria2  || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.TelefonoRefBancaria2  || ''}`,
                style: "infoTablas",
              },
            ] :  [],
          ],
        },
        layout: 'lightHorizontalLines'
      } :
      {
        table: {
          widths: ["90%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"NoDatosBancarios",Language)}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      },

      // ----------------------------------------------------------------PARTE IV--------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteIV",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 5, 0, 10],
      },

      {
        text: `${getLabel(FormatoInscripcionLang, "accounts", Language)}`,
        style: "infoTablasTitle",
        margin: [0, 5, 0, 5],
      },


      customerInfoTempo?.ContactoCuentasPorPagar ?
      {
        table: {
          widths: ["4%", "41%", "30%", "25%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"No.",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"NombreT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"EmailT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"TelT",Language)}`,
                style: "infoTablasHeader",
              },
            ],
            [
              {
                text: `1`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.ContactoCuentasPorPagar || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.CorreoCuentasPorPagar || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.TelefonoCuentasPorPagar || ''}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      } :
      {
        table: {
          widths: ["90%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"NoDatosCuentas",Language)}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      },
      ,

      // ----------------------------------------------------------------PARTE V--------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteV",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 5, 0, 10],
      },

      {
        table: {
          widths: ["8%", "90%"],
          margin: [0, -5, 0, 0],
          body: [
            [
              {
                text: `5.1`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req51", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `5.2`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req52", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `5.3`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req53", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `5.4`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req55", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `5.5`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req56", Language)}`,
                style: "infoTablas2",
              },
            ],
            // [
            //   {
            //     text: `5.6`,
            //     style: "infoTablasTitle2",
            //   },
            //   {
            //     text: `${getLabel(FormatoInscripcionLang, "req57", Language)}`,
            //     style: "infoTablas2",
            //   },
            // ],
            // [
            //   {
            //     text: `5.7`,
            //     style: "infoTablasTitle2",
            //   },
            //   {
            //     text: `${getLabel(FormatoInscripcionLang, "req58", Language)}`,
            //     style: "infoTablas2",
            //   },
            // ],
            [
              {
                text: `5.6`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req59", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `5.7`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req510", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: ``,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: ``,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req1", Language)}`,
                style: "infoTablas2",
              },
            ],
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 10],
      },

      // ----------------------------------------------------------------PARTE VI--------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteVI",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 10, 0, 10],
      },

      {
        table: {
          widths: ["8%", "90%"],
          body: [
            [
              {
                text: `6.1`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req61", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `6.2`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req62", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `6.3`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req63", Language)}`,
                style: "infoTablas2",
              },
            ],

          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 10],
      },

      // ---------------------------------------------------------------- PARTE VII --------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteVII",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 10, 0, 10],
      },

      {
        table: {
          widths: ["8%", "90%"],
          body: [
            [
              {
                text: `7.1`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req71", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `7.2`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req72", Language)}`,
                style: "infoTablas2",
              },
            ],
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 10],
      },


      {
        table: {
          widths: ["43%", "10%" ,"43%"],
          body: [

            [
              {
                image: logoPPFBase64.imgBlanco,
                height: 70,
                border:[false, false, false, false],
              },
              {
                text: ' ',
                border:[false, false, false, false],
              },
              {
                image: logoPPFBase64.imgBlanco,
                height: 70,
                border:[false, false, false, false],
              },
            ],

            [
              {
                text: ` ${getLabel(FormatoInscripcionLang,"nombreRepresentante",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false],
              },
              {
                text: ' ',
                border:[false, false, false, false],
              },
              {
                text: ` ${getLabel(FormatoInscripcionLang,"signature",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false],
              },
            ],

          ],
        },
        margin: [20, 5, 0, 0],
      },

      {
        table: {
          widths: ["96%"],
          body: [
            [
              {
                text: [
                  {
                    text: `${getLabel(FormatoInscripcionLang, "solicitudFirmadaText", Language)}`, 
                    style: "textInitial",
                  },
                  {
                    text: "jvasquez@ppf.com.hn /administracion@ppf.com.hn.", 
                    style: "infoTablasHeader"
                  }
                ],
              },
            ],
          ],
        },
        margin: [20, 15, 0, 20],
        layout: {
          hLineStyle: function () {
            return { dash: { length: 5, space: 3 } }; // Estilo de línea punteada
          },
          vLineStyle: function () {
            return { dash: { length: 5, space: 3 } }; // Estilo de línea punteada para las verticales
          },
          hLineWidth: function () {
            return 1; // Grosor de la línea
          },
          vLineWidth: function () {
            return 1; // Grosor de la línea
          }
        }
      },

      // ---------------------------------------------------------------- PARTE VIII --------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteVIII",Language)}`,
                style: "subtitleCenter",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 3, 0, 10],
      },

      {
        table: {
          widths: ["40%","15%","2%", "15%", "2%", "*"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"validada",Language)}`,
                style: "infoTablasF",
                border:[false, false, false, false]
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Yes",Language)}`,
                style: "infoTablasRight",
                border:[false, false, false, false]
              },
              {
                text: ` `,
                style: "infoTablas",
                border:[true, true, true, true]
              },
              {
                text: `No`,
                style: "infoTablasRight",
                border:[false, false, false, false]
              },
              {
                text: ` `,
                style: "infoTablas",
                border:[true, true, true, true]
              },
              {
                text: ` `,
                style: "infoTablas",
                border:[false, false, false, false]

              },
            ],

            [
              {
                text: `${getLabel(FormatoInscripcionLang,"plazo",Language)}`,
                style: "infoTablasF",
                margin: [0, 5, 0, 0],
                border:[false, false, false, false]
              },
              {
                margin: [0, 5, 0, 0],
                text: `${customerInfoTempo?.TermName || ''}`,
                style: "infoTablasJustify",
                colSpan: 5,
                border:[false, false, false, true]
              },
              {},
              {},
              {},
              {},
            ],

            [
              {
                text: `${getLabel(FormatoInscripcionLang,"limite",Language)}`,
                style: "infoTablasF",
                margin: [0, 5, 0, 0],
                border:[false, false, false, false]
              },
              {
                margin: [0, 5, 0, 0],
                text: `${(customerInfoTempo?.CreditLimit)?.toFixed(2) || ''}`,
                style: "infoTablasJustify",
                colSpan: 5,
                border:[false, false, false, true]
              },
              {},
              {},
              {},
              {},
            ],
          ],
        },
        margin: [0, 8, 0, 10],
      },

      // ---------------------------------------------------------------- FIRMAS --------------------------------------------------------------------
      {
        table: {
          widths: ["40%","10%","40%"],
          body: [
            [
              {
                image: logoPPFBase64.imgBlanco,
                height: 100,
                border:[false, false, false, false],
              },
              {
                text: ` `,
                border:[false, false, false, false]
              },
              {
                image: logoPPFBase64.imgBlanco,
                height: 100,
                border:[false, false, false, false],
              },
            ],
            [
              {
                text: ` ${getLabel(FormatoInscripcionLang,"autorizada",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false],
              },
              {
                text: ``,
                style: "infoTablasTitle3",
                border:[false, false, false, false]
              },
              {
                text: ` ${getLabel(FormatoInscripcionLang,"evaluada",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false]
              },
            ],

          ],
        },
        margin: [85,0, 20, 0],
      },

    ]


    let contenido2 =
    [
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 550,
            y2: 0, // Ajusta x2 para que la línea sea más larga o más corta
            lineWidth: 0.3, // Espesor de la línea
          },
        ],
      },
      {
        text: `${getLabel(FormatoInscripcionLang, "textInitial", Language)}`,
        style: "textInitial",
        margin: [0, 10, 0, 10],
      },

      // -------------------------------------------------------------------- PARTE I --------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteI",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
      },

      {
        table: {
          widths: ["28%", "72%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"dateA",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",
                margin: [0,10,0,0],
              },
              { 
                text: customerInfoTempo?.DateEditStr || '',
                border: [false, false, false, true],
                style: "infoTablas",
                margin: [0,10,0,0],
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"name",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerTempo?.CustomerName || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"address",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerTempo?.Address || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            // [
            //   {
            //     text: `${getLabel(FormatoInscripcionLang,"invoice",Language)}`,
            //     border: [false, false, false, false],
            //     style: "infoTablasHeader",

            //   },
            //   { 
            //     text: `${customerInfoTempo?.InvoicesToBe || ''}`,
            //     border: [false, false, false, true],
            //     style: "infoTablas",
            //   },
            // ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"billed",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.BilledToAddress || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["46%", "54%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"business",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerTempo?.RTN || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["9%", "29%", "5%","25%", "7%", "25%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Tel",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.Tel?.substring(0,35) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Fax:",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.Email?.substring(0,26) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["28%", "40%", "7%","25%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Representante",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.NombreRepresentanteLegal?.substring(0, 49) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.CorreoRepresentante?.substring(0,26) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["15%", "*"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"TipoPago",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.IdTipoPagoCliente === 1 ? 'No' : getLabel(FormatoInscripcionLang,"Si",Language)}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["8%", "32%", "8%","27%", "9%", "16%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"InfFinanciera",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasTitle",
                colSpan: 6,
                margin: [0,20,0,0],
              },
              { 
                text: ``,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: ``,
                border: [false, false, false, false],
                style: "infoTablas",

              },
              { 
                text: ``,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: ``,
                border: [false, false, false, false],
                style: "infoTablas",

              },
              { 
                text: ``,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Nombre",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.NombreContactoFin1?.substring(0, 34)  || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.CorreoContactoFin1?.substring(0, 35) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Tel",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.TelefonoContactoFin1?.substring(0, 20) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"Nombre",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.NombreContactoFin2?.substring(0, 34) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Email",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.CorreoContactoFin2?.substring(0, 35) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Tel",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.TelefonoContactoFin2?.substring(0, 20) || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },
      {
        table: {
          widths: ["15%", "85%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"MetodoPago",Language)}`,
                border: [false, false, false, false],
                style: "infoTablasHeader",

              },
              { 
                text: `${customerInfoTempo?.TipoPago || ''}`,
                border: [false, false, false, true],
                style: "infoTablas",
              },
            ]
          ],
        },
        margin: [0, 10, 0, 0],
        layout: {
          hLineWidth: function(i, node) {
            return 0.3; // Líneas horizontales más delgadas
          },
          vLineWidth: function(i, node) {
            return 0.3; // Líneas verticales más delgadas
          }
        }
      },

      // --------------------------------------------------------------- PARTE II --------------------------------------------------------------------
  
      // ----------------------------------------------------------------PARTE III--------------------------------------------------------------------

      // ----------------------------------------------------------------PARTE IV--------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteIV_1",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 5, 0, 10],
      },

      {
        text: `${getLabel(FormatoInscripcionLang, "accounts_1", Language)}`,
        style: "infoTablasTitle",
        margin: [0, 5, 0, 5],
      },


      customerInfoTempo?.ContactoCuentasPorPagar ?
      {
        table: {
          widths: ["4%", "41%", "30%", "25%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"No.",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"NombreT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"EmailT",Language)}`,
                style: "infoTablasHeader",
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"TelT",Language)}`,
                style: "infoTablasHeader",
              },
            ],
            [
              {
                text: `1`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.ContactoCuentasPorPagar || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.CorreoCuentasPorPagar || ''}`,
                style: "infoTablas",
              },
              {
                text: `${customerInfoTempo?.TelefonoCuentasPorPagar || ''}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      } :
      {
        table: {
          widths: ["90%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"NoDatosCuentas",Language)}`,
                style: "infoTablas",
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines'
      },
      ,

      // ----------------------------------------------------------------PARTE V--------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteV_1",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 5, 0, 10],
      },

      {
        table: {
          widths: ["8%", "90%"],
          margin: [0, -5, 0, 0],
          body: [
            [
              {
                text: `3.1`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req51", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `3.2`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req58", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `3.3`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req59", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `3.4`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req510", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: ``,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: ``,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req1", Language)}`,
                style: "infoTablas2",
              },
            ],
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 10],
      },

      // ----------------------------------------------------------------PARTE VI--------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteVI_1",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 10, 0, 10],
      },

      {
        table: {
          widths: ["8%", "90%"],
          body: [
            [
              {
                text: `4.1`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req61", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `4.2`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req62", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `4.3`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req63", Language)}`,
                style: "infoTablas2",
              },
            ],

          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 10],
      },

      // ---------------------------------------------------------------- PARTE VII --------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteVII_1",Language)}`,
                style: "subtitle",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 10, 0, 10],
      },

      {
        table: {
          widths: ["8%", "90%"],
          body: [
            [
              {
                text: `5.1`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req71", Language)}`,
                style: "infoTablas2",
              },
            ],
            [
              {
                text: `5.2`,
                style: "infoTablasTitle2",
              },
              {
                text: `${getLabel(FormatoInscripcionLang, "req72", Language)}`,
                style: "infoTablas2",
              },
            ],
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 10],
      },


      {
        table: {
          widths: ["43%", "10%" ,"43%"],
          body: [

            [
              {
                image: logoPPFBase64.imgBlanco,
                height: 70,
                border:[false, false, false, false],
              },
              {
                text: ' ',
                border:[false, false, false, false],
              },
              {
                image: logoPPFBase64.imgBlanco,
                height: 70,
                border:[false, false, false, false],
              },
            ],

            [
              {
                text: ` ${getLabel(FormatoInscripcionLang,"nombreRepresentante",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false],
              },
              {
                text: ' ',
                border:[false, false, false, false],
              },
              {
                text: ` ${getLabel(FormatoInscripcionLang,"signature",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false],
              },
            ],

          ],
        },
        margin: [20, 5, 0, 0],
      },

      {
        table: {
          widths: ["96%"],
          body: [
            [
              {
                text: [
                  {
                    text: `${getLabel(FormatoInscripcionLang, "solicitudFirmadaText", Language)}`, 
                    style: "textInitial",
                  },
                  {
                    text: "jvasquez@ppf.com.hn /administracion@ppf.com.hn.", 
                    style: "infoTablasHeader"
                  }
                ],
              },
            ],
          ],
        },
        margin: [20, 15, 0, 20],
        layout: {
          hLineStyle: function () {
            return { dash: { length: 5, space: 3 } }; // Estilo de línea punteada
          },
          vLineStyle: function () {
            return { dash: { length: 5, space: 3 } }; // Estilo de línea punteada para las verticales
          },
          hLineWidth: function () {
            return 1; // Grosor de la línea
          },
          vLineWidth: function () {
            return 1; // Grosor de la línea
          }
        }
      },

      // ---------------------------------------------------------------- PARTE VIII --------------------------------------------------------------------
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"parteVIII",Language)}`,
                style: "subtitleCenter",
                border: [false, false, false, false],
                fillColor: "#91238f",
                color: "white",
              },
            ],
          ],
        },
        margin: [0, 3, 0, 10],
      },

      {
        table: {
          widths: ["40%","15%","2%", "15%", "2%", "*"],
          body: [
            [
              {
                text: `${getLabel(FormatoInscripcionLang,"validada",Language)}`,
                style: "infoTablasF",
                border:[false, false, false, false]
              },
              {
                text: `${getLabel(FormatoInscripcionLang,"Yes",Language)}`,
                style: "infoTablasRight",
                border:[false, false, false, false]
              },
              {
                text: ` `,
                style: "infoTablas",
                border:[true, true, true, true]
              },
              {
                text: `No`,
                style: "infoTablasRight",
                border:[false, false, false, false]
              },
              {
                text: ` `,
                style: "infoTablas",
                border:[true, true, true, true]
              },
              {
                text: ` `,
                style: "infoTablas",
                border:[false, false, false, false]

              },
            ],

            [
              {
                text: `${getLabel(FormatoInscripcionLang,"plazo",Language)}`,
                style: "infoTablasF",
                margin: [0, 5, 0, 0],
                border:[false, false, false, false]
              },
              {
                margin: [0, 5, 0, 0],
                text: `${customerInfoTempo?.TermName || ''}`,
                style: "infoTablasJustify",
                colSpan: 5,
                border:[false, false, false, true]
              },
              {},
              {},
              {},
              {},
            ],

            [
              {
                text: `${getLabel(FormatoInscripcionLang,"limite",Language)}`,
                style: "infoTablasF",
                margin: [0, 5, 0, 0],
                border:[false, false, false, false]
              },
              {
                margin: [0, 5, 0, 0],
                text: `${(customerInfoTempo?.CreditLimit)?.toFixed(2) || ''}`,
                style: "infoTablasJustify",
                colSpan: 5,
                border:[false, false, false, true]
              },
              {},
              {},
              {},
              {},
            ],
          ],
        },
        margin: [0, 8, 0, 10],
      },

      // ---------------------------------------------------------------- FIRMAS --------------------------------------------------------------------
      {
        table: {
          widths: ["40%","10%","40%"],
          body: [
            [
              {
                image: logoPPFBase64.imgBlanco,
                height: 100,
                border:[false, false, false, false],
              },
              {
                text: ` `,
                border:[false, false, false, false]
              },
              {
                image: logoPPFBase64.imgBlanco,
                height: 100,
                border:[false, false, false, false],
              },
            ],
            [
              {
                text: ` ${getLabel(FormatoInscripcionLang,"autorizada",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false],
              },
              {
                text: ``,
                style: "infoTablasTitle3",
                border:[false, false, false, false]
              },
              {
                text: ` ${getLabel(FormatoInscripcionLang,"evaluada",Language)}`,
                style: "infoTablasTitle3",
                border:[false, true, false, false]
              },
            ],

          ],
        },
        margin: [85,0, 20, 0],
      },

    ]


    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [30, 90, 30, 90],

      //--------------------------------------------------------------------------HEADER--------------------------------------------------------------------
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                image: logoPPFBase64.logo,
                width: 200,
                margin: [4, -10, -10, -10],
              },
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "Title",
                    Language
                  )}`,
                  style: "title",
                  margin: [-10, 20, 0, 0],
                  width: 350,
                },
                {
                  text: "PRIDE PERFORMANCE FABRICS S.A. DE C.V.",
                  style: "titulo",
                  margin: [-10, 3, 0, 0],
                },
                {
                  text: "KM. 19.5 CARRETERA A OCCIDENTE, QUIMISTÁN, SANTA BÁRBARA, HONDURAS, C.A.",
                  style: "titulo",
                  margin: [-10, 3, 0, 0],
                },
              ],
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "codigoP",
                    Language
                  )} \n ${customerTempo?.CodigoCliente || ""}`,
                  style: "numeroDoc",
                  width: 100,
                  margin: [0, 20, 0, 0],
                },
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "Version",
                    Language
                  )} ${"03" || ""}`,
                  style: "date",
                  width: 100,
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "Date",
                    Language
                  )} ${fechaFormateada || ""}`,
                  style: "date",
                  width: 100,
                  margin: [0, 1, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      //--------------------------------------------------------------------------FOOTER--------------------------------------------------------------------
      footer: (currentPage, pageCount) => {
        return {
          table: {
            widths: ["*"],
            body: [
                [
                  {
                    text: `${currentPage} / ${pageCount}`,
                    border: [false, false, false, false],
                    style: "infoFooter2",
                  },
                ],
                [
                  {
                    image: logoPPFBase64.footerMembrete,
                    width: 530,
                    margin: [35, 0, -50, -30],
                    border: [false, false, false, false] 
                  }
                ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0;
            },
            vLineWidth: function (i, node) {
              return i === 1 || i === 2 ? 0.5 : 0;
            },
            vLineColor: function (i, node) {
              return i === 1 || i === 2 ? "#A0A0A0" : "transparent";
            },
          },
          margin: [0, 10, 0, 0],
        }
      },

      // -------------------------------------------------------------------- CONTENIDO------------------------------------------------------------

      

      content: customerInfoTempo?.IdTipoPagoCliente !== 1 ? contenido1 : contenido2,
     
      
  

      // -------------------------------------------------------------------- ESTILOS ------------------------------------------------------------
      
      
      
      
      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        infoFooter2: {
          fontSize: 10,
          margin: [0, 0, 50, 0],
          alignment: 'right'
        },
        titulo: {
          fontSize: 8,
          // margin: [0, 50, 0, 0],
          // bold: true,
          alignment: "justify",
        },
        date: {
          fontSize: 9,
          // margin: [0, 50, 0, 0],
          // bold: true,
          alignment: "center",
        },
        title: {
          fontSize: 11,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "center",
        },
        textInitial: {
          fontSize: 9,
          margin: [10, 0, 10, 0],
          // bold: true,
          alignment: "justify",
        },

        infoTablas: {
          fontSize: 9,
          // margin: [0, 0, 0, 0],
          // bold: true,
          alignment: "left",
        },
        infoTablasCenter: {
          fontSize: 9,
          // margin: [0, 0, 0, 0],
          // bold: true,
          alignment: "center",
        },
        infoTablasRight: {
          fontSize: 10,
          // margin: [0, 0, 0, 0],
          // bold: true,
          alignment: "right",
        },
        infoTablasJustify: {
          fontSize: 10,
          // margin: [0, 0, 0, 0],
          // bold: true,
          // alignment: "right",
        },

        infoTablasF: {
          fontSize: 10,
          // margin: [0, 0, 0, 0],
          // bold: true,
          alignment: "justify",
        },
        infoTablas2: {
          fontSize: 9,
          // margin: [0, 0, 0, 0],
          // bold: true,
          alignment: "left",
        },
        infoTablasHeader: {
          fontSize: 9,
          // margin: [0, 0, 0, 0],
          bold: true,
          alignment: "justify",
        },
        infoTablasTitle: {
          fontSize: 11,
          // margin: [0, 0, 0, 0],
          bold: true,
          alignment: "justify",
        },
        infoTablasTitle2: {
          fontSize: 10,
          // margin: [0, 0, 0, 0],
          bold: true,
          alignment: "right",
        },
        infoTablasTitle3: {
          fontSize: 10,
          // margin: [0, 0, 0, 0],
          bold: true,
          alignment: "center",
        },
        numeroDoc: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
        subtitle: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
        },
        subtitleCenter: {
          fontSize: 9,
          bold: true,
          alignment: "center",
        },

      },
    };

    pdfMake.createPdf(docDefinition).open({}, window);
  };
};

export default FormatoInscripcionClientes;
